/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  //##################################
  //#   MIXINS FOR REUSABLE GRAPHS  ##
  //##################################
  var d3;

  d3 = require("d3");

  window.genericDataUpdate = {
    updateGraphSelections: function(selected = []) {
      this.selected = selected;
      return this.updateColors();
    },
    changeData: function(data_in, x_axis_var_in, x_axis_var_time_check_in, date_pattern_in, needToSort = true, selected = []) {
      var end, i, j, len, ref, start, temp;
      this.x_axis_var = x_axis_var_in;
      this.x_axis_var_time_check = x_axis_var_time_check_in;
      this.date_pattern = date_pattern_in;
      this.parseDate = d3.time.format(`${this.date_pattern}`).parse;
      if (x_axis_var_time_check_in) {
        this.data = data_in;
        ref = this.data;
        for (j = 0, len = ref.length; j < len; j++) {
          i = ref[j];
          if (typeof i[this.x_axis_var] === 'string') {
            temp = this.parseDate(i[this.x_axis_var]);
            i[this.x_axis_var] = temp;
          }
        }
      } else {
        if (needToSort) {
          this.data = data_in.sort(function(a, b) {
            if (parseFloat(b[this.x_axis_var]) < parseFloat(a[this.x_axis_var])) {
              return 1;
            } else {
              return -1;
            }
          });
        } else {
          this.data = data_in;
        }
      }
      this.stat_list = d3.keys(this.data[0]).filter(function(key) {
        this.x_axis_var = x_axis_var_in;
        if (key !== this.x_axis_var) {
          return key;
        }
      });
      start = this.data[0];
      this.startDate = start[this.x_axis_var];
      end = this.data[this.data.length - 1];
      this.endDate = end[this.x_axis_var];
      this.selected = selected;
      return this.clearGraphandUpdate();
    }
  };

  window.genericScatterDataUpdate = {
    changeData: function(data_in, x_axis_var_in) {
      this.data = data_in;
      this.stat_list = d3.keys(this.data[0]).filter(function(key, i) {
        this.x_axis_var = x_axis_var_in;
        if (key !== this.x_axis_var) {
          return key;
        }
      });
      if (!this.chosen_x || !this.isInArray(this.chosen_x, this.stat_list)) {
        this.chosen_x = this.stat_list[0];
        this.chosen_y = this.stat_list[1];
      }
      if (!this.chosen_x || !this.isInArray(this.chosen_x, this.stat_list)) {
        this.chosen_x = this.stat_list[0];
        this.chosen_y = this.stat_list[1];
      }
      return this.update();
    }
  };

  window.basicInteractivity = {
    changeStart: function(new_start_index) {
      var temp;
      temp = this.data[new_start_index];
      this.startDate = temp[x_axis_var];
      return this.clearGraphandUpdate();
    },
    changeEnd: function(new_end_index) {
      var temp;
      temp = this.data[new_end_index];
      this.endDate = temp[x_axis_var];
      return this.clearGraphandUpdate();
    },
    restrictObjByDate: function(array_in, date_var) {
      var date, i, limited;
      date_var = date_var || "date";
      limited = [];
      i = 0;
      while (i < array_in.length) {
        date = +array_in[i][date_var];
        if (date >= this.startDate && date <= this.endDate) {
          limited.push(array_in[i]);
        }
        i += 1;
      }
      return limited;
    },
    isInArray: function(value, array) {
      return array.indexOf(value) > -1;
    }
  };

  window.genericControlElements = {
    clear: function(selector) {
      return $(selector).empty();
    },
    createSelect: function(append_to, label_text, form_id, form_items, disable_option) {
      var _self;
      _self = this;
      disable_option = disable_option || false;
      $(append_to).append(`<label>${label_text}:</label>`);
      $(append_to).append(`<select class='form-control' id='${form_id}-${this.graph_id}' ></select>`);
      if (disable_option) {
        $(`#${form_id}-${_self.graph_id}`).append('<option selected> -- Select an Option -- </option>');
      }
      return $.each(form_items, function(index) {
        return $(`#${form_id}-${_self.graph_id}`).append($("<option></option>").val(index).text(_self.map_text ? _self.map_text[form_items[index]] : form_items[index]));
      });
    },
    createSelect2Type: function(append_to, label_text, form_id, form_items, variable_in, disable_option, map_list) {
      var _self, disable, holder, i, j, len, select_data, temp;
      _self = this;
      form_items = form_items || [];
      variable_in = variable_in || null;
      disable_option = disable_option || false;
      holder = `${form_id}-${_self.graph_id}-holder`;
      if (!map_list) {
        select_data = [];
        for (j = 0, len = form_items.length; j < len; j++) {
          i = form_items[j];
          temp = {};
          temp["text"] = _self.map_text[i] ? _self.map_text[i] : i;
          temp["id"] = i;
          select_data.push(temp);
        }
      } else {
        select_data = form_items;
      }
      if (disable_option) {
        disable = {
          "text": `Disable ${label_text}`,
          "id": "Disable"
        };
        select_data.unshift(disable);
      }
      $(append_to).append(`<label class='select-label'>${label_text}:</label>`);
      $(append_to).append(`<div id=${holder}></div>`);
      $(`#${holder}`).select2({
        data: select_data,
        width: "100%",
        placeholder: 'Select an Option'
      });
      if (variable_in) {
        $(`#${holder}`).select2("val", variable_in);
      }
      return $(`#${holder}`).change(function(event) {
        if ($(this).val() === 'Disable') {
          return $(`#${holder}`).select2("val", "");
        }
      });
    },
    createCheckList: function(append_to, label_text, form_id, form_name, form_items, checked) {
      var _self, i, j, len, results;
      _self = this;
      $(append_to).append(`<label>${label_text}:</label>`);
      $(append_to).append($("<form>").attr('id', `${form_id}-${this.graph_id}`));
      results = [];
      for (j = 0, len = form_items.length; j < len; j++) {
        i = form_items[j];
        results.push($(`#${form_id}-${this.graph_id}`).append($("<input>").attr("type", "checkbox").attr("name", `${this.graph_id}-${form_name}`).attr("value", `${i}`).prop('checked', checked ? true : false).text(`${i}`)).append($(`<span>${i}</span></br>`)));
      }
      return results;
    },
    createSlider: function(append_to, label_text, form_id, min_value, max_value, current_value) {
      var _self, ticklabels, ticks, tickvals, val;
      _self = this;
      $(append_to).append(`<label>${label_text}:</label>`);
      tickvals = (function() {
        var j, ref, ref1, results;
        results = [];
        for (val = j = ref = min_value * 10, ref1 = max_value * 10; (ref <= ref1 ? j <= ref1 : j >= ref1); val = ref <= ref1 ? ++j : --j) {
          results.push(val / 10);
        }
        return results;
      })();
      ticks = "[" + tickvals.join() + "]";
      ticklabels = "[" + ((function() {
        var j, len, results;
        results = [];
        for (j = 0, len = tickvals.length; j < len; j++) {
          val = tickvals[j];
          results.push("'" + String(val) + "'");
        }
        return results;
      })()).join() + "]";
      $(append_to).append($("<input>").attr("id", `${form_id}-${this.graph_id}`).attr("data-slider-id", `${form_id}-${this.graph_id}-slider`).attr("type", "text").attr("data-slider-min", `${min_value}`).attr("data-slider-max", `${max_value}`).attr("data-slider-step", "0.1").attr("data-slider-precision", "0.1").attr("data-slider-value", `${current_value}`));
      return $(`#${form_id}-${this.graph_id}`).slider({
        formatter: function(val) {
          return 100 * val;
        }
      });
    }
  };

  window.scatterInteractivityElements = {
    fakeToggles: function(selector, selector2) {
      var _self, select_color_by, select_size_by, select_x_axis, select_y_axis;
      _self = this;
      selector2 = selector2 || selector;
      this.clear(selector);
      this.clear(selector2);
      select_x_axis = "chosen-x";
      select_y_axis = "chosen-y";
      select_color_by = "color-by";
      select_size_by = "size-by";
      this.createSelect2Type(selector, "X-Axis", select_x_axis);
      this.createSelect2Type(selector, "Y-Axis", select_y_axis);
      this.createSelect2Type(selector2, "Color By", select_color_by);
      return this.createSelect2Type(selector2, "Size By", select_size_by);
    },
    interactiveToggles: function(selector, selector2) {
      var _self, select_color_by, select_size_by, select_x_axis, select_y_axis;
      _self = this;
      selector2 = selector2 || selector;
      this.clear(selector);
      this.clear(selector2);
      select_x_axis = "chosen-x";
      select_y_axis = "chosen-y";
      select_color_by = "color-by";
      select_size_by = "size-by";
      this.createSelect2Type(selector, "X-Axis", select_x_axis, this.stat_list, this.chosen_x, false, true);
      this.createSelect2Type(selector, "Y-Axis", select_y_axis, this.stat_list, this.chosen_y, false, true);
      this.createSelect2Type(selector2, "Color By", select_color_by, this.stat_list, this.chosen_color_by, true, true);
      this.createSelect2Type(selector2, "Size By", select_size_by, this.stat_list, this.chosen_size_by, true, true);
      $(`#${select_x_axis}-${this.graph_id}-holder`).change(function(event) {
        var new_x_axis_var;
        new_x_axis_var = $(this).val();
        return _self.changeXAxisVar(new_x_axis_var);
      });
      $(`#${select_y_axis}-${this.graph_id}-holder`).change(function(event) {
        var new_y_axis_var;
        new_y_axis_var = $(this).val();
        return _self.changeYAxisVar(new_y_axis_var);
      });
      $(`#${select_color_by}-${this.graph_id}-holder`).change(function(event) {
        var new_color_by;
        new_color_by = $(this).val();
        return _self.changeColorBy(new_color_by);
      });
      return $(`#${select_size_by}-${this.graph_id}-holder`).change(function(event) {
        var new_size_by;
        new_size_by = $(this).val();
        return _self.changeSizeBy(new_size_by);
      });
    }
  };

}).call(globalThis);
